module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Generator.js"));
	}, "Generator");
}